const MD_BREAKPOINT = 744;

export default function initBreadcrumb() {
  const breadcrumbs = document.querySelectorAll(".breadcrumb");

  if (!breadcrumbs.length) return;

  breadcrumbs.forEach((breadcrumb) => {
    // Find existing toggle wrapper from HTML
    const toggleWrapper = breadcrumb.querySelector(".breadcrumb-toggle-wrapper");
    if (!toggleWrapper) return;

    const toggleBtn = toggleWrapper.querySelector(".breadcrumb-toggle");
    const dropdown = toggleWrapper.querySelector(".breadcrumb-dropdown");
    if (!toggleBtn || !dropdown) return;

    // Get all items except toggle wrapper
    const allItems = breadcrumb.querySelectorAll("li:not(.breadcrumb-toggle-wrapper)");

    // Only enable collapsible if more than 2 items (home > page > subpage)
    if (allItems.length <= 2) {
      // Not collapsible - mark as ready so CSS shows items on mobile
      breadcrumb.classList.add("is-ready");
      return;
    }

    // Mark breadcrumb as collapsible - CSS will show toggle and hide items on mobile
    breadcrumb.classList.add("is-collapsible");

    const hiddenItems = Array.from(allItems).slice(0, -1);

    // Clone hidden items into dropdown
    hiddenItems.forEach((item) => {
      const link = item.querySelector("a");
      if (link) {
        const dropdownItem = document.createElement("a");
        dropdownItem.href = link.href;
        // Home link only has icon, use "Home" text instead
        dropdownItem.textContent = link.classList.contains("home")
          ? "Home"
          : link.textContent;
        dropdown.appendChild(dropdownItem);
      }
    });

    // Toggle dropdown
    let isOpen = false;

    function closeDropdown() {
      isOpen = false;
      toggleWrapper.classList.remove("is-open");
    }

    toggleBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      isOpen = !isOpen;
      toggleWrapper.classList.toggle("is-open", isOpen);
    });

    // Close on outside click
    document.addEventListener("click", (e) => {
      if (!toggleWrapper.contains(e.target)) {
        closeDropdown();
      }
    });

    // Close on escape
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeDropdown();
      }
    });

    // Close dropdown on resize to desktop
    const mediaQuery = window.matchMedia(`(max-width: ${MD_BREAKPOINT - 1}px)`);
    mediaQuery.addEventListener("change", (e) => {
      if (!e.matches) {
        closeDropdown();
      }
    });
  });
}
